import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import { artifactStore } from "@/hooks";
import {
  Typography,
  PanelCard,
  AttributeListDisplay,
  Separator,
} from "@/components/common";
import { ArtifactSummary } from "@/components/artifact/save";
import ArtifactNameDisplay from "./ArtifactNameDisplay.vue";


/**
 * Displays the selected node's title and option buttons.
 */
const __default__ = {
  name: "ArtifactContent",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const artifact = computed(() => artifactStore.selectedArtifact);
const body = computed(() => artifact.value?.body.trim() || "");
const isCode = computed(() => !!artifact.value?.isCode);
const variant = computed(() => (isCode.value ? "code" : "expandable"));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), { borderless: "" }, {
    default: _withCtx(() => [
      (artifact.value)
        ? (_openBlock(), _createBlock(ArtifactNameDisplay, {
            key: 0,
            artifact: artifact.value,
            "display-type": "",
            "display-tooltip": "",
            "is-header": "",
            "data-cy-name": "text-selected-name",
            "data-cy-type": "text-selected-type"
          }, null, 8, ["artifact"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(Separator), {
        b: "2",
        t: "1"
      }),
      _createVNode(_unref(Typography), {
        variant: "caption",
        value: "Body"
      }),
      _createVNode(_unref(Typography), {
        "default-expanded": "",
        "collapse-length": 0,
        variant: variant.value,
        value: body.value,
        "data-cy": "text-selected-body"
      }, null, 8, ["variant", "value"]),
      _createVNode(_unref(ArtifactSummary)),
      (!!artifact.value)
        ? (_openBlock(), _createBlock(_unref(AttributeListDisplay), {
            key: 1,
            artifact: artifact.value
          }, null, 8, ["artifact"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})